var AdditionalCustomerFieldBuilderErrors = {

  general: function (errors) {
    var err = []
    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors.field && errors.field.length) {
      for (var i = 0, ilen = errors.field.length; i < ilen; i++) {
        err.push(I18n.t('field') + ' ' + errors.field[i]);
      }
    }
    
    if (errors.required && errors.required.length) {
      for (var i = 0, ilen = errors.required.length; i < ilen; i++) {
        err.push(I18n.t('required') + ' ' + errors.required[i]);
      }
    } 
    return err
  },

  options: function(errors) {
    var err = []
    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    return err
  }

}

export default AdditionalCustomerFieldBuilderErrors